import {FetchEntityService} from "./FetchEntityService";
import {Comment} from "../../model/comment/Comment";

export class CommentService extends FetchEntityService<Comment> {
    static readonly MaxSize = 10000;

    constructor() {
        super('comment');
    }
}